import { createFileRoute } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { DashboardLayout } from "@/screens/Dashboard/components/DashboardLayout"

export const Route = createFileRoute("/app/dashboard/_layout")({
  component: () => (
    <PermissionContentWrapper
      permissions={[PermissionActionType.DASHBOARD_PENDING_APPROVALS, PermissionActionType.DASHBOARD_MY_REQUESTS]}
    >
      <DashboardLayout />
    </PermissionContentWrapper>
  ),
})
